import { useState, useEffect } from 'react';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '平台特色', href: '#features' },
  { label: '焦点专题', href: '#carousel' },
  { label: '吃瓜群众说', href: '#comments' },
  { label: '吃瓜问答', href: '#faq' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[72px] md:h-[80px]">
          <a
            href="#hero"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick('#hero');
            }}
            className="flex items-center gap-2 no-underline"
          >
            <span className="text-xl md:text-2xl font-heading font-bold text-primary-500 whitespace-nowrap">
              每日大赛<span className="text-foreground-800">mrds</span>
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(item.href);
                }}
                className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 ${
                  scrolled
                    ? 'text-foreground-700 hover:text-primary-500'
                    : 'text-foreground-800 hover:text-primary-500'
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-200/70 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`} />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4">
          <nav className="flex flex-col gap-3">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(item.href);
                }}
                className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors py-2 whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}